import {TraceContent} from '../components'
import {PLUGIN_TYPE} from '../constants'

import TraceEventEmitterController from './TraceEventEmitterController'
import TraceProvider from './TraceProvider'

import type {BaseTabConfig, Plugin} from '../type'
import type {TraceOptions} from './type'

const plugin: Plugin = {
    type: PLUGIN_TYPE.TRACE,
    Controller: TraceEventEmitterController,
    Provider: TraceProvider,
}

type ApplyTraceTabProps = Omit<BaseTabConfig, 'plugin' | 'Content'> & TraceOptions

export const applyTraceTab = (props: ApplyTraceTabProps): BaseTabConfig => {
    const {filterScope, ...rest} = props

    return {
        ...rest,
        plugin,
        Content: <TraceContent filterScope={filterScope} />,
    }
}
